import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { Link } from 'react-router'
import cn from 'classnames'
import VisibilitySensor from 'react-visibility-sensor'

class SkillsSection extends React.Component {
  
  static propTypes() {
    return {
      shouldReanimate: React.PropTypes.boolean
    }
  }

  constructor() {
    super();
    //'rgba(127,127,255,0.5)'

    this.state = {
      isBrowser: false,
      showData: false,
      shouldReanimated: false
    };

    let chartFillColor = 'rgba(179,181,198,0.5)';
    let chartBorderColor = 'rgba(179,181,198,1)';
    let chartHoverFillColor = 'rgba(127,127,255,0.5)';
    let chartHoverBorderColor = 'rgba(127,127,255,1)';

    this.generalSkillsData = {
          labels: ["Frontend Web", "Backend Web", "iOS", "Android", "Graphics Programming", "UX Designing", "Project Management"],
          datasets: [
            {
                label: 'Skill',
                backgroundColor: chartFillColor,
                borderColor: chartBorderColor,
                pointBackgroundColor: chartBorderColor,
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: chartBorderColor,
                data: [85, 60, 70, 82, 50, 60, 40],
                lineTension: 0.5,
            }
          ]
      };

    this.generalSkillsOptions = {
      defaultColor: 'rgba(255,0,0,0.05)',
      defaultFontColor: 'white',
      legend: {
            display: false,
            labels: {
                fontColor: 'rgb(255, 99, 132)'
            }
        },
      elements: {
        line: {
          tension: 0.4 // no bezier1in radar
        }
      },
      backgroundColor:'white',
      scale: {
        gridLines: {
          color: 'rgba(255,255,255,0.1)',
          zeroLineColor: 'rgba(255,255,255,0.2)',
          zeroLineWidth: 2,
          lineWidth: 2,
          drawTicks: false,
          drawBorder: false,
          drawOnChartArea: false,
        },
        angleLines: {
          color: 'rgba(255,255,255,0.1)',
          lineWidth: 2
        },
        pointLabels: {
          fontColor: 'rgba(255,255,255,0.5)',
        },
        ticks: {
          display: false,
          beginAtZero: true,
          color: 'rgba(255,255,255,0.2)'
        }
      }
    };

    this.programmingSkillsData = {
       labels: ['Javascript', 'HTML', 'CSS', 'PHP', 'Java', 'Swift', 'Objective-C', 'C++'],
        datasets: [
          {
            label: 'Skill',
            backgroundColor: chartFillColor,
            borderColor: chartBorderColor,
            borderWidth: 2,
            hoverBackgroundColor: chartHoverFillColor,
            hoverBorderColor: chartHoverBorderColor,
            data: [85, 83, 82, 60, 78, 72, 40, 30]
          }
        ]
    };

    this.programmingSkillsOptions = {
      // maintainAspectRatio: false,
      // scale: {
      //   gridLines: {
      //     color: 'rgba(255,255,255,0.1)',
      //   },
      //   ticks: {
      //     display: false
      //   }
      // },
      scales: {
          xAxes: [{
            gridLines: {
              color: 'rgba(255,255,255,0.1)',
              zeroLineColor: 'rgba(255,255,255,0.0)',
            },
            ticks: {
              fontColor: 'white',
            }
          }],
          yAxes: [{
            gridLines: {
              color: 'rgba(255,255,255,0.1)',
              zeroLineColor: 'rgba(255,255,255,0.1)',
              zeroLineWidth: 2,
            },
            ticks: {
              display: false,
              beginAtZero: true
            }
          }]
      },
      legend: {
        display: false,
      }
    };
  }

  componentDidMount() {
    this.setState({ isBrowser: true });
  }

  componentWillReceiveProps(nextProps) {
    console.log('will receive props');
    console.log(nextProps);
  }

  onScrollChange(visibility){
    console.log('visibility');
    console.log(visibility);
    //console.log(this.refs.radarchart);
    //console.log(this.refs.barchart);

    // if(visibility){
    //   if(this.refs.radarchart){ 
    //     this.refs.radarchart.chart_instance.render(1000, false);
    //   }
    //   if(this.refs.barchart) {
    //     this.refs.barchart.chart_instance.render(1000, false);
    //   }
    // } else {
    //   if(this.refs.radarchart){ 
    //     //this.refs.radarchart.chart_instance.reset();
    //   }
    //   if(this.refs.barchart) {
    //     //this.refs.barchart.chart_instance.reset();
    //   }
    // }

    if(visibility) {
      //this.setState({showData: true});
    } else {
      //this.setState({showData: false});
    }
  }

  renderSkillRadarChart() {
    var Chart = require('react-chartjs-2');
    return <div className="center">
      <h3>Overall</h3>
      <br/>
      <Chart.Radar 
        ref="radarchart"
        data={this.props.shouldReanimate ? this.generalSkillsData : {}} 
        options={this.generalSkillsOptions} 
        width="600" height="400"/>
    </div>;
  }

  renderSkillBarChart() {
    var Chart = require('react-chartjs-2');
    return <div className="center">
      <h3>Programming Languages</h3>
      <br/>
      <Chart.Bar
          ref="barchart"
          data={this.props.shouldReanimate ? this.programmingSkillsData : {}}
          width={600}
          height={300}
          options={this.programmingSkillsOptions}
      />
    </div>;
  }

  render () {
    return (
      <Container
        style={{
          maxWidth: 1170,
          paddingTop: 0,
          padding: `${rhythm(1)} ${rhythm(3/4)}`,
        }}
      >
        <div className="section">
          <div className="section-header section-header-white">
            <h2>Skills</h2>
          </div>
            <Grid columns={12} className="navbar">
              <Breakpoint minWidth={900} widthMethod="componentWidth">
                <Span columns={6}>
                  {this.renderSkillRadarChart()}
                </Span>
                <Span columns={6} last>
                  {this.renderSkillBarChart()}
                </Span>      
              </Breakpoint>
              <Breakpoint maxWidth={900} widthMethod="componentWidth">
                <Span columns={12}>
                  {this.renderSkillRadarChart()}
                  {this.renderSkillBarChart()}
                </Span>
              </Breakpoint>
            </Grid>
        </div>
      </Container>
    );
  }
}

export default SkillsSection



/** WEBPACK FOOTER **
 ** ../components/SkillsSection.js
 **/